import { registerLayout, ViewType } from '@kunlun/dependencies';

export const installDutySchedule = () => {
  registerLayout(
    `
      <view type="TABLE">
        <element widget="DutyScheduleCalendar" slot="table" />
      </view>
    `,
    {
      viewType: ViewType.Table,
      model: 'deli.aries.seller.DeliAriesSellerDutySchedule'
    }
  );
};

installDutySchedule();
